<template>
    <div>
        <v-container fluid>
            <div v-if="loading">
                <v-layout wrap>
                    <v-flex 
                        xs12 
                        px-3
                    >
                        <v-skeleton-loader 
                            class="mx-auto" 
                            type="heading"
                        />
                    </v-flex>
                </v-layout>
                <br>
                <v-layout wrap>
                    <v-flex
                        v-for="i in [1, 2, 3, 4]"
                        :key="'sl_docto_' + i"
                        xs12
                        text-sm-right
                        px-3
                    >
                        <v-skeleton-loader type="card-heading" />
                    </v-flex>
                </v-layout>
            </div>
            <documentos-externo v-else-if="valido && !loading" />
            <v-alert 
                v-else 
                type="error"
            >
                Usted no cuenta con el permiso para acceder a esta página.
            </v-alert>
        </v-container>
    </div>
</template>
<script>
import { mapGetters, mapState } from "vuex";

export default {
  name: "MisDocumentosExterno",
  components: {
    DocumentosExterno: () =>
      import("../../components/organisms/DocumentosExterno")
  },
  data () {
    return {
      settings: {
        maxScrollbarLength: 60
      },
      valido: false,
      loading: true
    };
  },
  computed: {
    ...mapGetters("oidc", ["oidcUser"]),
    ...mapState(['empleadoDatos','profile']),
    esExterno () {
      return this.profile.Es_Externo
    }
  },
  watch:{
    esExterno: {
      handler (newValue, oldValue) {
        //if(newValue != null) {
          this.validarAcceso();
        //}
      },
    },
  },
  beforeMount () {},
  mounted () {
    if(this.esExterno == true) {
      this.validarAcceso();
    }
  },
  methods: {
    async validarAcceso () {
      var self = this;
      self.loading = true;
      self.valido = false;

      if (this.profile.Es_Externo == 1) {
        self.valido = true;

        self.loading = false;
      } else {
        self.valido = false;

        self.loading = false;
      }
    }
  }
};
</script>
